import { Dimensions, Modal, Platform, ScrollView, StyleSheet, TouchableOpacity, View } from 'react-native';
import React, { useEffect, useState } from 'react';
import { ButtonTypeDLS, ButtonWidthTypeToken, ColorTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, SizeTypeTokens, TextAlignTokens, TypographyTypeDLS } from '@voltmoney/schema';
import InstaStory from 'react-native-insta-story';
import HeroSection from './HeroSection';
import SubHeading from './SubHeading';
import InfoSection from './InfoSection';
import HorizontalScrollScreen from './HorizontalScrollScreen';
import ManageLimitScreen from './ManageLimitScreen';
import ResultSection from './ResultSection';
import FAQScreen from './FAQScreen';
import FooterScreen from './FooterScreen';
import TransactionScreen from './TransactionScreen';
import { HOME_ICON, HOME_ICON_FOCUSED, LIMIT_ICON, LIMIT_ICON_FOCUSED, TRANSACTION_ICON, TRANSACTION_ICON_FOCUSED } from './constant';
import HeaderScreen from './HeaderScreen';
import { StoryData } from './Data';
import { Typography } from "../../typography/Typography";
import { Space } from "../../space/Space";
import { isMobile } from "../../stack/utils";
import { getScreenType } from "../bankSelectPage/BankSelect";
import ThemeProvider from "@voltmoney/theme";
import BottomSheet from "../BottomSheet";
import { ModalAlignmentEnum } from "@voltmoney/types";
import { Icon } from "../../icon/Icon";
import { Button } from "../../button/Button";
import NeedHelpDC from '../NeedHelpDC';
import { createShimmerPlaceholder } from 'react-native-shimmer-placeholder';
import LinearGradient from 'react-native-linear-gradient';
import { InterestCalculatorCard } from './InterestCalculatorCard';
const BorrowerLandingScreen = ({ height, fetchMF, triggerAction, amount, firstName, needHelpAction, navigateToProfileAction, logoutAction, navigatetoFaq, userName, showLogout, showEditLimit, continueAction, shouldShowEditLimit, continueEditLimitAction, latestDateOfEdit, loading, contactUsDetails, onLoadComplete = false, navToIC, showInterestCalculator }) => {
    const [screen, setScreen] = useState("Home");
    const [homeIcon, setHomeIcon] = useState(HOME_ICON_FOCUSED);
    const [transactionIcon, setTransactionIcon] = useState(TRANSACTION_ICON);
    const [limitIcon, setLimitIcon] = useState(LIMIT_ICON);
    const [totalAmount, setTotalAmount] = useState(amount);
    const [homeText, setHomeText] = useState(true);
    const [transactionText, setTransactionText] = useState(false);
    const [limitText, setLimitText] = useState(false);
    const [logout, setLogout] = useState(false);
    const [onEditLimitPressed, setOnEditLimitPressed] = useState(false);
    const [editLimit, setEditLimit] = useState(false);
    const [showNeedHelp, setShowNeedHelp] = useState(false);
    const theme = ThemeProvider.getTheme();
    const colorMapping = theme.colors;
    const backgroundColor = colorMapping[ColorTokens.Primary_05];
    const ShimmerPlaceholder = createShimmerPlaceholder(LinearGradient);
    const url = Platform.OS === 'web' ? window.location.href : '';
    const isFromPhonePe = url.includes('PHONEPE');
    const handleHomeIcon = () => {
        setScreen("Home");
        setHomeIcon(HOME_ICON_FOCUSED);
        setTransactionIcon(TRANSACTION_ICON);
        setLimitIcon(LIMIT_ICON);
        setHomeText(true);
        setTransactionText(false);
        setLimitText(false);
    };
    const handleTransactionScreen = () => {
        setScreen("Transaction");
        setHomeIcon(HOME_ICON);
        setTransactionIcon(TRANSACTION_ICON_FOCUSED);
        setLimitIcon(LIMIT_ICON);
        setHomeText(false);
        setTransactionText(true);
        setLimitText(false);
    };
    const handleLimitScreen = () => {
        setScreen("Limit");
        setHomeIcon(HOME_ICON);
        setTransactionIcon(TRANSACTION_ICON);
        setLimitIcon(LIMIT_ICON_FOCUSED);
        setHomeText(false);
        setTransactionText(false);
        setLimitText(true);
    };
    useEffect(() => {
        setTotalAmount(amount);
    }, [amount]);
    useEffect(() => {
        //@ts-ignore
        if (!showEditLimit) {
            triggerAction({
                ...shouldShowEditLimit
            });
        }
    }, [showEditLimit]);
    useEffect(() => {
        if (screen === "Transaction" || screen === "Limit") {
            setEditLimit(false);
        }
        else {
            setEditLimit(true);
        }
    }, [screen]);
    const handleNeedHelp = () => {
        setShowNeedHelp(true);
    };
    const logoutModal = () => {
        return (logout && React.createElement(Modal, { animationType: 'fade', transparent: true, onRequestClose: () => {
            } },
            React.createElement(View, { style: {
                    flex: 1,
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '100%',
                    height: '100%',
                    backgroundColor: '#1D293966',
                } },
                React.createElement(View, { style: {
                        backgroundColor: 'white',
                        width: '70%',
                        maxWidth: 508,
                        height: '20%',
                        borderRadius: 10,
                        justifyContent: 'center',
                        alignItems: 'center',
                        borderColor: 'black',
                        borderWidth: 2,
                        padding: 10,
                    } },
                    React.createElement(Typography, { label: "Are you sure you want to logout?", color: ColorTokens.Grey_Charcoal, fontSize: FontSizeTokens.SM, fontFamily: FontFamilyTokens.Poppins, fontWeight: "400", lineHeight: 24, textAlign: TextAlignTokens.center }),
                    React.createElement(Space, { size: SizeTypeTokens.MD }),
                    React.createElement(View, { style: {
                            flexDirection: 'row',
                            justifyContent: 'space-evenly',
                            width: '100%',
                            height: 35,
                            alignItems: 'center',
                        } },
                        React.createElement(View, { style: {
                                flexDirection: 'row',
                                justifyContent: 'space-evenly',
                                width: '100%',
                            } },
                            React.createElement(View, { nativeID: 'txt_logOutScreen_yes' },
                                React.createElement(TouchableOpacity, { style: styles.checkContainer, onPress: () => {
                                        triggerAction({
                                            ...logoutAction
                                        });
                                    } },
                                    React.createElement(Typography, { label: "Yes", color: ColorTokens.Primary_100, fontSize: FontSizeTokens.SM, fontWeight: "400", lineHeight: 18 }))),
                            React.createElement(View, { nativeID: 'txt_logOutScreen_no' },
                                React.createElement(TouchableOpacity, { style: styles.checkContainer, onPress: () => {
                                        setLogout(false);
                                    } },
                                    React.createElement(Typography, { label: "No", color: ColorTokens.Primary_100, fontSize: FontSizeTokens.SM, fontWeight: "400", lineHeight: 18 })))))))));
    };
    const renderEditLimitConfirmationBox = () => {
        return (React.createElement(View, { style: { position: 'absolute', bottom: 0 } },
            React.createElement(BottomSheet, { autoAdjustHeight: false, height: Platform.OS !== "web" ? 342 : 272, width: '100%', alignment: ModalAlignmentEnum.BOTTOM, backgroundColor: 'transparent', hasDraggableIcon: false, sheetBackgroundColor: 'white', isDismissible: true, radius: 4, screenHeight: isMobile(getScreenType(Dimensions.get('window').width)) ? Platform.OS !== "ios" ? Dimensions.get('window').height + 10 : Dimensions.get('window').height : height, screenWidth: isMobile(getScreenType(Dimensions.get('window').width)) ? Dimensions.get('window').width : 508, routeId: "routeId", handleKeyboard: true, closeFunction: () => {
                    setOnEditLimitPressed(false);
                } },
                React.createElement(View, { style: {
                        justifyContent: 'center',
                        padding: 16,
                        paddingTop: 24,
                        alignContent: 'center',
                        alignItems: 'center'
                    } },
                    React.createElement(Icon, { name: IconTokens.SystemWarning, size: IconSizeTokens.XXXXXXL }),
                    React.createElement(View, { style: { marginTop: 24, marginBottom: 24 } },
                        React.createElement(Typography, { typeDLS: TypographyTypeDLS.H4S, label: "Are you sure you want to edit your limit? This will reset your selected limit", textAlign: TextAlignTokens.center })),
                    React.createElement(Button, { typeDLS: ButtonTypeDLS.PRIMARY, label: "Yes, continue to edit limit", width: ButtonWidthTypeToken.FULL, onPress: () => {
                            triggerAction({
                                ...continueEditLimitAction
                            });
                        } }),
                    React.createElement(Space, { size: SizeTypeTokens.LG }),
                    React.createElement(Button, { typeDLS: ButtonTypeDLS.SECONDARY, label: "No, continue with selected limit", width: ButtonWidthTypeToken.FULL, onPress: () => {
                            setOnEditLimitPressed(false);
                        } })))));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(View, { style: {
                height: Platform.OS === "ios" ? height - 8 : height,
                width: '100%',
                paddingBottom: Platform.OS === "ios" ? 4 : 0
            } },
            (screen === "Home" && totalAmount === 0) &&
                React.createElement(View, { style: styles.header },
                    React.createElement(HeaderScreen, { title: 'Welcome', subTitle: '', trailIcon: "true", needHelpIcon: !isFromPhonePe, needHelpAction: handleNeedHelp, navigateToProfileAction: () => triggerAction(navigateToProfileAction), logoutIcon: showLogout, logoutAction: () => {
                            setLogout(true);
                        }, triggerAction: triggerAction })),
            (screen === "Home" && totalAmount > 0) &&
                React.createElement(View, { style: styles.header },
                    React.createElement(HeaderScreen, { title: firstName?.length <= 10 ? 'Welcome, ' : 'Welcome!', subTitle: firstName?.length <= 10 ? firstName : '', trailIcon: "true", needHelpIcon: true, needHelpAction: handleNeedHelp, navigateToProfileAction: () => triggerAction(navigateToProfileAction), logoutIcon: showLogout, logoutAction: () => {
                            setLogout(true);
                        }, triggerAction: triggerAction })),
            screen == "Transaction" && (React.createElement(React.Fragment, null,
                React.createElement(View, { style: styles.header },
                    React.createElement(HeaderScreen, { title: 'Transactions', subTitle: '', trailIcon: "", logoutIcon: showLogout })))),
            screen == "Limit" && (React.createElement(React.Fragment, null,
                React.createElement(View, { style: styles.header },
                    React.createElement(HeaderScreen, { title: 'Manage Limit', subTitle: '', trailIcon: "", logoutIcon: false })))),
            React.createElement(View, null,
                React.createElement(ScrollView, { style: { height: height } },
                    screen === "Home" && React.createElement(ScrollView, { style: [styles.homeContainer, { backgroundColor: backgroundColor }] },
                        Dimensions.get('window').width < 765 ?
                            React.createElement(InstaStory, { data: StoryData, duration: 10, style: Platform.OS !== 'web' ? styles.instaStoryContainer : {
                                    // paddingHorizontal: 16,
                                    marginTop: 82,
                                    flex: 1,
                                }, avatarWrapperStyle: Platform.OS !== 'web' ? styles.wrapper : {
                                    ...Platform.OS === 'web' && !isMobile(getScreenType(Dimensions.get('window').width)) ? { width: 508 / 5 } : { width: Dimensions.get('window').width / 4.5 },
                                }, avatarTextStyle: Platform.OS !== 'web' ? styles.wrapper : {
                                    ...Platform.OS === 'web' && !isMobile(getScreenType(Dimensions.get('window').width)) ? { width: 508 / 7 } : { width: Dimensions.get('window').width / 6.5 },
                                    marginLeft: 12,
                                    alignItems: 'center',
                                    color: '#667085'
                                }, unPressedBorderColor: 'transparent', pressedBorderColor: 'transparent', pressedAvatarTextColor: '#667085', unPressedAvatarTextColor: '#667085', storyImageStyle: styles.storyImageStyle }) : React.createElement(React.Fragment, null,
                            React.createElement(View, { style: { height: 64 } })),
                        !onLoadComplete && (React.createElement(View, { style: { padding: 16 } },
                            React.createElement(ShimmerPlaceholder
                            // stopAutoRun
                            , { 
                                // stopAutoRun
                                style: {
                                    width: '50%',
                                    height: 24,
                                    marginTop: 24,
                                    borderRadius: 8,
                                } }))),
                        (totalAmount > 0 && onLoadComplete) && React.createElement(SubHeading, { label: "Your instant cash is ready" }),
                        (totalAmount === 0 && onLoadComplete) && React.createElement(HeroSection, { fetchMF: fetchMF, triggerAction: triggerAction, loading: loading, onLoadComplete: onLoadComplete }),
                        !onLoadComplete && (React.createElement(View, { style: { padding: 16 } },
                            React.createElement(ShimmerPlaceholder
                            // stopAutoRun
                            , { 
                                // stopAutoRun
                                style: {
                                    width: '100%',
                                    height: 180,
                                    borderRadius: 8,
                                } }))),
                        (totalAmount > 0 && onLoadComplete) &&
                            React.createElement(ResultSection, { fetchMF: fetchMF, triggerAction: triggerAction, latestDateOfEdit: latestDateOfEdit, loading: loading, totalAmount: totalAmount, showEditLimit: showEditLimit, onEditLimitPressed: setOnEditLimitPressed }),
                        React.createElement(SubHeading, { label: "Why Volt Money you ask?" }),
                        React.createElement(InfoSection, null),
                        React.createElement(View, { style: { height: 16 } }),
                        (showInterestCalculator || Platform.OS === 'ios' || Platform.OS === 'android') &&
                            React.createElement(InterestCalculatorCard, { triggerAction: triggerAction, navAction: navToIC }),
                        React.createElement(SubHeading, { label: "Learn about Loan against MF" }),
                        React.createElement(HorizontalScrollScreen, null),
                        React.createElement(FAQScreen, { navigatetoFaq: navigatetoFaq, triggerAction: triggerAction })),
                    (screen === "Transaction" || screen === "Limit") &&
                        React.createElement(View, { style: [styles.screen, { height: height }] },
                            screen == "Transaction" && (React.createElement(React.Fragment, null,
                                React.createElement(TransactionScreen, null))),
                            screen == "Limit" && (React.createElement(React.Fragment, null,
                                React.createElement(ManageLimitScreen, null)))))),
            React.createElement(FooterScreen, { homeIcon: homeIcon, transactionIcon: transactionIcon, limitIcon: limitIcon, homeText: homeText, transactionText: transactionText, limitText: limitText, handleHomeIcon: handleHomeIcon, handleTransactionScreen: handleTransactionScreen, handleLimitScreen: handleLimitScreen })),
        logout && logoutModal(),
        onEditLimitPressed && editLimit && renderEditLimitConfirmationBox(),
        showNeedHelp && React.createElement(NeedHelpDC, { showNeedHelp: showNeedHelp, setShowNeedHelp: setShowNeedHelp, contactUsDetails: contactUsDetails })));
};
export default BorrowerLandingScreen;
const styles = StyleSheet.create({
    homeContainer: {
        flex: 1,
        paddingBottom: Platform.OS === "ios" ? 22 : 0
    },
    screen: {
        flex: 1,
        paddingBottom: Platform.OS === "ios" ? 22 : 0
    },
    header: {
        position: 'absolute',
        top: 0,
        width: '100%',
        height: 82,
        zIndex: 99,
    },
    instaStoryContainer: {
        marginLeft: 12,
        marginTop: Platform.OS === "ios" ? 106 : 82,
        display: 'flex',
        flexDirection: 'row',
        ...Platform.OS === 'ios'
            && {
                flex: 1,
                justifyContent: 'space-between',
                width: Dimensions.get('window').width,
            },
    },
    wrapper: {
        width: Dimensions.get('window').width / 5,
        borderColor: 'transparent',
    },
    storyText: {
        width: Platform.OS === 'ios'
            ? Dimensions.get('window').width / 6
            : Dimensions.get('window').width / 7,
        marginLeft: Platform.OS === 'ios' ? 10 : 12,
        ...Platform.OS === 'ios'
            && {
                display: 'flex',
                flex: 1,
                justifyContent: 'center',
            },
        alignItems: 'center',
        color: '#667085'
    },
    storyImageStyle: {
        resizeMode: 'stretch',
    },
    checkContainer: {
        width: 60,
        height: 40,
        alignItems: 'center',
        justifyContent: 'center',
    },
});
